import { helper } from '@ember/component/helper';

export const isInCollection = (params) =>
  (params[1] || []).mapBy('id').includes(String(params[0].id));

export default helper(isInCollection);
